import { customerServiceApi } from '@/pages/CustomerService/services';
import { tasksService } from '@/pages/Scheduler/services';
import { AssignmentsService } from '@/pages/Fleet/Assignment/services';
import { CostService } from '@/pages/Fleet/Cost/services';
import derivationsService from '@/pages/SILA/services/derivations.service';
import { agendasService } from '@/pages/AttendTrack/pages/Agendas/services';
import { requestsService } from '@/pages/Inventory/pages/Requests/services';
import {
  VehiclesService,
  VehiclesTypesService,
} from '@/pages/Fleet/Vehicles/services';
import { monitorInformationService } from '@/pages/AttendTrack/pages/Monitors/services';
import {
  preInvoiceService,
  preCostsService,
} from '@/pages/Fleet/Finances/services';
import { scheduledPendingService } from '@/pages/AttendTrack/pages/PreparePackage/services';
import {
  DriversService,
  SchedulesService,
  CostModesService,
} from '@/pages/Fleet/Drivers/services';
import {
  inboxService,
  totemSectorService,
  sectorsService,
} from '@/pages/AttendTrack/pages/Inbox/services';
import { dashboardService } from '@/pages/AttendTrack/pages/Dashboard/services';
import {
  BusinessesService,
  FeeServicesService,
  ServicesTypeService,
} from '@/pages/Fleet/Businesses/services';
import { dashboardAtcService } from '@/pages/CustomerService/pages/Dashboard/services';
import { usersService } from '@/pages/Inventory/pages/Users/services';
import companiesService from '@/pages/Fleet/Companies/services/companies.service';
import { fleetDashboardService } from '@/pages/Fleet/Dashboard/services';
import {
  assetsService,
  brandsService,
  assetModelsService,
  typesService,
} from '@/pages/Inventory/pages/Assets/service';
import { inventoryAssignmentsService } from '@/pages/Inventory/pages/Assignments/service';
import { serviceHistoryService } from '@/pages/Inventory/pages/ServiceHistory/service';
import { suppliersService } from '@/pages/Inventory/pages/Suppliers/service';
import {
  LogisticOperatorsService,
  LogisticOperatorGroupsService,
  GeographicService,
  TimeSlotsService,
  CommercialServicesService,
  ServiceWithOperatorService,
  ZonesService,
  ZoneTypesService,
  FlowsService,
  TransitionsService,
  ShippingStatusesService,
  TransitionIncludedStatusesService,
  TransitionExcludedStatusesService,
} from '@/pages/Business/pages/LogisticOperator/services';
import commerceShippingsService from '@/pages/BusinessCommerces/services/commerceShippings.service';
import supportMaterialsService from '@/pages/BusinessCommerces/services/supportMaterials.service';
import { externalOperatorService } from '@/pages/BusinessExternalOperators/services/externalOperatorService';
import {
  shippingsService,
  shippingOptionsService as shippingsShippingOptionsService,
  addressesService,
  geocodingService,
  shippingHistoryService,
  visitsService,
  HeadquarterLogisticOperatorsService,
  routingService,
} from '@/pages/Business/pages/Shippings/services';
import eventsService from '@/pages/Business/pages/Shippings/services/events.service';
import { geographicOptionsService } from '@/pages/Business/services';
import {
  CommercesService,
  CommerceSettingsService,
  CommerceGroupsService,
  AddressService,
  NeighborhoodService,
  GeographicService as CommerceGeographicService,
  LogisticOperatorsService as CommerceLogisticOperatorsService,
  LogisticOperatorAssociationService,
  BranchesService,
  BranchSettingsService,
  CommerceWithServiceService,
  CommerceMeliIntegrationService,
} from '@/pages/Business/pages/Commerce/services';
import { RoutesService } from '@/pages/Business/pages/Monitoring/services';
import { activeDriversService } from '@/pages/Business/pages/DriverMonitoring/services';
import {
  usersService as businessUsersService,
  rolesService as businessRolesService,
  userRolesService as businessUserRolesService,
} from '@/pages/Business/pages/Users/services';
import { driversService as businessDriversService } from '@/pages/Business/pages/Drivers/services';
import { registerService, otpVerifyService } from '@/pages/Register/services';
import { appsVersionsService } from '@/pages/AppsVersions/services';
import { cityService } from '@/pages/Inventory/pages/Geography/Cities/services';
import { departmentService } from '@/pages/Inventory/pages/Geography/Departments/services';
import { officesService } from '@/pages/Inventory/pages/Geography/Offices/services';
import { businessService } from '@/pages/Business/services/business.service';
import { locationsService } from '@/pages/Business/pages/Shippings/pages/Locations/services';
import { pickupAuditService } from '@/pages/Business/pages/Shippings/pages/PickupAudit/services';
import { includedPickupCommercesService } from '@/pages/Business/pages/Commerce/pages/IncludedPickupCommerces/services';
import { pickupCyclesService } from '@/pages/Business/pages/PickupCycles/services';
import { ServiceVisitTypesService } from '@/pages/Business/pages/ServiceVisitTypes/services';
import { trackingIconsService } from '@/pages/InstitutionalWeb/LiveTracking/services';
import type { Middleware, Reducer } from '@reduxjs/toolkit';

interface ApiServiceLike {
  reducerPath: string;
  reducer: Reducer;
  middleware: Middleware;
  util: { resetApiState: () => { type: string } };
}

const services: (ApiServiceLike | undefined)[] = [
  pickupAuditService,
  locationsService,
  includedPickupCommercesService,
  pickupCyclesService,
  ServiceVisitTypesService,
  trackingIconsService,
  requestsService,
  AssignmentsService,
  BusinessesService,
  FeeServicesService,
  ServicesTypeService,
  DriversService,
  SchedulesService,
  CostModesService,
  VehiclesService,
  VehiclesTypesService,
  CostService,
  customerServiceApi,
  dashboardAtcService,
  fleetDashboardService,
  agendasService,
  inboxService,
  totemSectorService,
  sectorsService,
  dashboardService,
  monitorInformationService,
  scheduledPendingService,
  preInvoiceService,
  preCostsService,
  derivationsService,
  tasksService,
  companiesService,
  usersService,
  assetsService,
  brandsService,
  typesService,
  assetModelsService,
  inventoryAssignmentsService,
  serviceHistoryService,
  suppliersService,
  LogisticOperatorsService,
  LogisticOperatorGroupsService,
  GeographicService,
  TimeSlotsService,
  CommercialServicesService,
  ServiceWithOperatorService,
  ZonesService,
  ZoneTypesService,
  FlowsService,
  TransitionsService,
  ShippingStatusesService,
  TransitionIncludedStatusesService,
  TransitionExcludedStatusesService,
  shippingsService,
  shippingsShippingOptionsService,
  addressesService,
  geocodingService,
  shippingHistoryService,
  visitsService,
  eventsService,
  HeadquarterLogisticOperatorsService,
  routingService,
  geographicOptionsService,
  CommercesService,
  CommerceSettingsService,
  CommerceGroupsService,
  AddressService,
  NeighborhoodService,
  CommerceGeographicService,
  CommerceLogisticOperatorsService,
  LogisticOperatorAssociationService,
  BranchesService,
  BranchSettingsService,
  CommerceWithServiceService,
  CommerceMeliIntegrationService,
  RoutesService,
  activeDriversService,
  businessUsersService,
  businessRolesService,
  businessUserRolesService,
  businessDriversService,
  registerService,
  otpVerifyService,
  appsVersionsService,
  cityService,
  departmentService,
  officesService,
  businessService,
  commerceShippingsService,
  supportMaterialsService,
  externalOperatorService,
];

const { reducers, middlewares } = services.reduce(
  (acc, service, index) => {
    if (!service) {
      console.error(
        `Service at index ${index} is undefined! Check servicesReducer.ts`
      );
      return acc;
    }
    acc.reducers[service.reducerPath] = service.reducer;
    acc.middlewares.push(service.middleware);

    return acc;
  },
  { reducers: {}, middlewares: [] } as {
    reducers: Record<string, any>;
    middlewares: Array<any>;
  }
);

export const servicesReducers = reducers;
export const servicesMiddlewares = middlewares;
export const allServices = services;
